import React, { useEffect } from 'react';
import { useGameEcosystem } from '@/hooks/useGameEcosystem';
import { useGameRealTimeManager } from '@/hooks/useGameRealTimeManager';
import { useAuthenticatedUser } from '@/hooks/useAuthenticatedUser';
import { toast } from 'sonner';

interface GameManagementIntegrationProps {
  children: React.ReactNode;
}

export const GameManagementIntegration: React.FC<GameManagementIntegrationProps> = ({
  children
}) => {
  const { user } = useAuthenticatedUser();
  const { notifyGameCreated } = useGameEcosystem();
  
  // Set up real-time manager for the authenticated user
  useGameRealTimeManager({
    userId: user?.id,
    onGameUpdate: () => {
      console.log('🎮 Game updated');
      toast.success('Game has been updated');
    },
    onRosterUpdate: () => {
      console.log('👥 Roster updated');
      toast.info('Game roster has been updated');
    },
    onPlayerStatusUpdate: () => {
      console.log('🏃 Player status updated');
      toast.info('Player status has been updated');
    },
    onConfirmationUpdate: () => {
      console.log('✅ Confirmation updated');
      toast.success('Game confirmation updated');
    },
    onGameStatusUpdate: () => {
      console.log('📊 Game status updated');
      toast.info('Game status has been updated');
    }
  });

  return <>{children}</>;
};